function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import each from 'lodash/each';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { cloneDeep } from 'lodash';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import FormContainerAbstract from 'components/FormContainerAbstract';
import StandardActions from 'components/Form/StadardActions';
import App from 'modules/App';
import Table from 'components/Table';
import * as actions from '../../../../actions';
import * as selectors from '../../../../selectors';
import messages from '../../../../messages';
import * as constants from '../../../../constants';
import validatorRules from './validatorRules.json';
import styles from './UnitsOfMeasurements.pcss';
class UnitsOfMeasurementsForm extends FormContainerAbstract {
    componentDidUpdate(prevProps) {
        this.setFormStatus();
        if (prevProps.isUpdateInProgress && !this.props.isUpdateInProgress) {
            this.onSetShouldReset();
        }
        if (this.state.shouldReset && !this.props.isFetchInProgress) {
            this.onInitialize();
        }
    }
    onSetShouldReset() {
        this.setState({
            shouldReset: true
        });
    }
    onInitialize() {
        this.setState({
            formInitialState: JSON.parse(JSON.stringify(this.props.unitMeasurements)),
            hasUnsavedChanges: false,
            shouldReset: false
        });
        this.props.onSetFormValues(this.props.unitMeasurements);
    }
    onReset() {
        this.props.onSetFormValues(this.props.unitMeasurements);
        this.props.onFormErrors(null);
    }
    setFormStatus() {
        const hasUnsavedChanges = !isEqual(this.state.formInitialState, this.props.formValues.values);
        if (this.state.hasUnsavedChanges !== hasUnsavedChanges) {
            this.setState({
                hasUnsavedChanges
            });
            this.props.onHasUnsavedChangesChanged(hasUnsavedChanges);
        }
    }
    get schema() {
        return [
            {
                key: 'metricName',
                labelMessage: messages.labels.metricName,
                renderer: (measurement)=>/*#__PURE__*/ _jsx("b", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.unitsOfMeasurements.names[measurement.id]))
                    })
            },
            {
                key: 'unit',
                labelMessage: messages.labels.metricUnit,
                renderer: (measurement)=>this.renderOptions(measurement)
            }
        ];
    }
    get entities() {
        const result = [];
        each(constants.UNITS_OF_MEASUREMENTS_OPTIONS, (value, key)=>{
            result.push({
                id: key,
                value: this.props.unitMeasurements[key],
                options: value
            });
        });
        return result;
    }
    renderOptions(measurement) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.measurement__options,
            children: measurement.options.map((option)=>/*#__PURE__*/ _jsx(FormGroup, {
                    id: measurement.id,
                    className: "mb-0",
                    formValues: this.props.formValues,
                    children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                        inputValue: option,
                        labelMessage: constants.UNITS_SYMBOLS[option],
                        value: measurement.value,
                        className: styles.measurement__options__value,
                        isRadio: true,
                        onChange: (input)=>this.onSetValue(input)
                    })
                }, `${measurement.id}-${option}`))
        });
    }
    renderTable() {
        return /*#__PURE__*/ _jsx(Table, {
            idKey: "id",
            schema: this.schema,
            entities: this.entities,
            perPage: 25,
            isPerPageOff: true
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            onReset: ()=>this.onReset(),
            children: [
                this.renderTable(),
                /*#__PURE__*/ _jsx(StandardActions, {
                    hasChanges: this.state.hasUnsavedChanges,
                    isInProgress: this.props.isUpdateInProgress || this.props.isFetchInProgress,
                    infoMessage: this.props.isConfiguredCountryActive ? messages.infos.saveOnActiveCountry : null
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            formInitialState: cloneDeep(this.props.unitMeasurements),
            hasUnsavedChanges: false,
            shouldReset: false
        };
        this.props.onSetFormValues(this.props.unitMeasurements);
        this.validatorRules = _object_spread({}, validatorRules);
    }
}
_define_property(UnitsOfMeasurementsForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    isFetchInProgress: PropTypes.bool.isRequired,
    // Explicit actions
    onClose: PropTypes.func,
    // Implicit props
    isUpdateInProgress: PropTypes.bool.isRequired
}));
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.CONFIGURE_COUNTRY_UNITS_OF_MEASUREMENTS_TAB_FORM)(state),
        unitMeasurements: selectors.unitMeasurements(state),
        isUpdateInProgress: selectors.isUpdateCountryConfigurationUnitOfMeasurementInProgress(state),
        isConfiguredCountryActive: selectors.isConfiguredCountryActive(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.CONFIGURE_COUNTRY_UNITS_OF_MEASUREMENTS_TAB_FORM;
    return {
        onSubmit: (values)=>dispatch(actions.updateCountryConfigurationUnitsOfMeasurements(values)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedUnitsOfMeasurementsForm = connect(mapStateToProps, mapDispatchToProps)(UnitsOfMeasurementsForm);
export default withStyles(styles)(ConnectedUnitsOfMeasurementsForm);
